import moment from "moment-timezone";

import { BusinessAssetType, DepreciableCategory } from "../../types";
import { SAVE_DATE_FORMAT } from "@/v1/constants";

export const DEPRECIABLE_CATEGORY_CODES = Object.values(
  DepreciableCategory
) as string[];
export const LATEST_POSSIBLE_PURCHASE_DATE = moment().format(SAVE_DATE_FORMAT);
export const CUSTOM_ASSET_CLASS = "Sonstige";

export const BUSINESS_ASSET_TYPE_NAMES: Record<BusinessAssetType, string> = {
  [BusinessAssetType.MOVABLE_MOTOR_VEHICLES]: "Kraftfahrzeuge",
  [BusinessAssetType.MOVABLE_OFFICE_EQUIPMENT]: "Büroausstattung",
  [BusinessAssetType.MOVABLE_OTHERS]: "Andere",
  [BusinessAssetType.IMMOVABLE]: "Unbewegliche Wirtschaftsgüter",
  [BusinessAssetType.INTANGIBLE]: "Immaterielle Wirtschaftsgüter",
};
